import { api } from '@/core/api/';

const URL = 'api/provider/monthcertification';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getDisciplineService = (
  academicYearId,
  month,
  companyId,
  specialistId
) =>
  api.get(
    `${URL}/services/${academicYearId}/${month}/${companyId}/${specialistId}`
  );

export const getActiveProviders = (academicYearId, month) =>
  api.get(`${URL}/activeproviders/${academicYearId}/${month}`);

export const getActiveSpecialistsByProvider = (
  academicYearId,
  monthNumber,
  companyId
) =>
  api.get(
    `${URL}/activespecialistbyprovider/${academicYearId}/${monthNumber}/${companyId}`
  );

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const uploadCertificationFiles = (payload) =>
  api.post(`${URL}/uploadfiles`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
